import type { IconProps } from './types';

export function Sutia({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M48 116 Q60 84 72 56 Q82 52 92 56 Q100 84 108 116 Q128 132 148 116 Q156 84 164 56 Q174 52 184 56 Q196 84 208 116 Q208 124 208 136 Q208 180 168 180 Q128 180 128 144 Q128 180 88 180 Q48 180 48 136 Q48 124 48 116 Z" />
    </svg>
  );
}
